import * as React from 'react';
import * as Styled from './DealTiles.styles';
import { DealTile } from './DealTile';

import { Deal as IDealsProps } from '../../lib/deals';
import { Templates } from '../index';

import { formatAirScheduleDate } from '../../lib/util';
import { AirSchedule } from '@lce/slice';
import { map as _map, includes as _includes } from 'lodash';

export interface IDealTilesProps {
  deals: IDealsProps[];
}

export const DealTiles: React.FC<IDealTilesProps> = ({deals}) => {
  return (
    <Styled.Container as="section">
      <Styled.Content>
        <Styled.DealsWrapper width={['100%', 'initial']}>
          {_map(deals, deal => {
            const hasMatchingTemplate = _includes(Object.keys(Templates), deal?.template);

            if(!hasMatchingTemplate && deal?.template?.length > 0){
                return null;
            }
    
             if (deal.dates && deal.dates.length > 0) {
              return _map(deal.dates, (date, index) => {
                const dates = formatAirScheduleDate(date.startDate, date.endDate);
                const DealTemplate = Templates[deal?.template];
              
                return (
                  <AirSchedule
                    {...dates}
                    key={`${deal.promo}${date.endDate}${Math.floor(Math.random() * 100).toString()}${index}`}
                  >
                    { !hasMatchingTemplate ? <DealTile {...deal} /> : <DealTemplate {...deal} locale={deal.locale} />}
                  </AirSchedule>
                );
              });
            } else {
              const dates = formatAirScheduleDate(deal.startDate, deal.endDate);

              return (
                <AirSchedule
                  {...dates}
                  key={`${deal.promo}${deal.endDate}${Math.floor(Math.random() * 100).toString()}`}
                >
                  <DealTile {...deal} />
                </AirSchedule>
              );
            }
          })}
        </Styled.DealsWrapper>
      </Styled.Content>
    </Styled.Container>
  );
};
